// Wave surface fragment — ivory / cream wax colour with depth shading

uniform float uTime;
varying vec2  vUv;
varying float vElevation;

void main() {
    // Colour based on elevation
    vec3 troughColor = vec3(0.75, 0.70, 0.62);   // warm shadow
    vec3 baseColor   = vec3(0.94, 0.90, 0.84);   // ivory mid-tone
    vec3 peakColor   = vec3(1.00, 0.97, 0.93);   // bright crest

    float norm = (vElevation + 0.22) / 0.44;      // normalise to 0–1
    vec3  col  = mix(troughColor, baseColor, smoothstep(0.0, 0.5, norm));
    col        = mix(col, peakColor,   smoothstep(0.6, 1.0, norm));

    // Specular highlight on crests
    float spec = smoothstep(0.78, 1.0, norm) * 0.45;
    col       += vec3(spec);

    // Soft rounded-rect vignette mask
    vec2  d    = abs(vUv - 0.5) * 2.2;
    float mask = 1.0 - smoothstep(0.72, 1.0, max(d.x, d.y));

    gl_FragColor = vec4(col, mask * 0.92);

    #include <colorspace_fragment>
}
